import axios from 'axios'
import urls from './urls'
import authToken from './authToken'
import logger from './logger'
import rules from './permissions'
import checkUIPermissions from './UIPermissions'
import tradeHelper from '@/common/tradeHelper';
//import store from './store'
import * as Msal from "@azure/msal-browser"; // if using CDN, 'Msal' will be available in global scope
import store from '../store';
import router from '../router/index';
import gridOptions from "./gridOptions"
import Cookies from 'js-cookie'
import * as jwt_decode from 'jwt-decode';
import { DialogUtility } from '@syncfusion/ej2-popups';

const authInterceptor = (request) => {
    var token = authToken.get();
    if (!token.length) {
        //throw new axios.Cancel("User is not logged in...");
    }
    request.headers['Authorization'] = `Bearer ${token}`;
    return request;
};

const config = {
    auth: {
        clientId: urls.azureADClientId,
        authority: "https://login.microsoftonline.com/" + urls.azureADTenantId + "/",
        redirectUri: `${window.location.protocol}//${window.location.host}`, //defaults to application start page
        postLogoutRedirectUri: "https://www.google.com/",
    },
};

const loginRequest = {
    scopes: ["User.ReadWrite"],
};

const myMsal = new Msal.PublicClientApplication(config);

const protectedApi = axios.create({
    baseURL: urls.apiBaseUrl
});

//Added by Haris Date correction for json serialization
function dateCorrection(request) {
    for (var key in request) {
        var value = request[key];

        if (Object.prototype.toString.call(value) === '[object Date]') {
            var date = tradeHelper.fixDateOffset(value);
            request[key] = date.toISOString();

        }
        if (Object.prototype.toString.call(value) === '[object Array]') {
            for (var i = 0; i < value.length; i++) {

                dateCorrection(value[i]);
            }

        }
    }
}
//Added by Haris Date correction for json serialization
const dateInterceptor = (request) => {
    if (request.data != undefined) {
        //This is only if request contains isDateFix true
        if (request.isDateFix != undefined && request.isDateFix == true) {
            dateCorrection(request.data);
        }

    }

    return request;

};

var logout = function () {
    //process.env.NODE_ENV !== 'production' ? Cookies.remove('SsoToken', { domain: '.alfaenergygroup.org' }) : Cookies.remove('SsoToken', { domain: '.alfaenergygroup.com' });
    //authToken.set();
    //localStorage.clear();
    //window.location.replace(`${urls.ssoBaseUrl}home/logout`)

    // AZURE AD PART BELOW
    authToken.set();
    localStorage.clear();

    const currentAccounts = myMsal.getAllAccounts();

    const logoutRequest = {
        account: myMsal.getAccountByHomeId(currentAccounts[0].homeAccountId),// accountId
    };

    myMsal.logoutRedirect(logoutRequest)

}

//var navigateToLogin = function () {
//    window.location.replace(urls.getReturnUrl());
//}
let triggeredMessage = false;
//AZURE AD LOGIN FUNC
var navigateToLogin = function (redirectLocation) {

    //This clean all grids enable perstance from filters 
    for (var i = 0; i < window.localStorage.length; i++) {
        if (window.localStorage.key(i).includes('gridgrid')) {
            window.localStorage.removeItem(window.localStorage.key(i));
        }
       
    }
    function NotifyUser() {
        if (!triggeredMessage) {
            setTimeout(function () {
                gridOptions.infoAlert(
                    "Disclaimer: All information provided to you via this platform is at all times subject to the terms and conditions of your agreement with Alfa Energy Limited, trading under the name Trio, and is provided 'as is' and 'as available'. Trio makes no representations or warranties of any kind, express or implied, as to the operation of this platform, or the information, content or materials included on this platform. You expressly agree that your use of this platform is at your sole risk.");
            }, 1500);
            triggeredMessage = true;
        }

        let tokenDecoded = jwt_decode(authToken.get());
        let isFirstTrioLogin = tokenDecoded["trioFirstLogin"] == "true" ? true : false;

        if (isFirstTrioLogin) {
            window.localStorage.setItem("firstTrioLogin", "true");
        }

        let showTrioDialog = window.localStorage.getItem("firstTrioLogin") == "true" ? true : false;
        if (showTrioDialog) {
            setTimeout(function () {
                DialogUtility.alert({
                    content: "<div class='dialog-content'style='margin-top: -5%'><div class='msg-wrapper' style='padding-bottom=1.5%'><div style='text-align:center'><img src='/logo/Trio_Logo.png' style='width:50%!important;'/></div>" +
                        "<div class='header' style='text-align:center; font-family: Arial; color: #4d4d4d;'><h2 style='font-weight: 550'>A new look</h2></div>" +
                        "<div class='disclaimer-text' style='text-align:center'><span style='font-family: Arial; color: #4d4d4d; font-size:20px'>We have a new name and a new look! Edison Energy, Alfa Energy, and Altenex Energy recently rebranded to Trio.</span></div>" +
                        "<div class='disclaimer-text' style='text-align:center'><span style='font-family: Arial; color: #4d4d4d; font-size:20px''> Visit www.trioadvisory.com to learn more</span></div>" +
                        "</div></div>",
                    animationSettings: { effect: 'Zoom' },
                    theme: 'Bootstrap',
                    showCloseIcon: true,
                    zIndex: 1100,
                    header: null,
                    cssClass: "trio-first-login",

                });
            }, 2500);
                protectedApi.put(`user/updateUserFirstTrioLogin`)
                .then(response => {
                    window.localStorage.setItem("firstTrioLogin", "false");
                }).catch(e => {
                    console.log(e);
                });
            

        }


    }
    function callApi(token) {
        unprotectedApi.post(
            "auth",
            {
                Token: token
            }
        ).then((r) => r.data).then((resp) => {
            authToken.set(resp.token || resp.Token);
            rules.getPermissions(resp.token || resp.Token);
            store.commit('setIsLoggedIn', true);
            checkUIPermissions();
            if (redirectLocation) {
                router.replace("/ssolanding")
            }
            router.replace("/home").then(() => {
                NotifyUser();
            });
            
             
        }).catch((err) => {
            //if not authenticated /passed auth verification let the user know
            if (err && err.response && err.response.data) {
                gridOptions.errorAlert(err.response.data.message);
            }
            else {
                console.log(err)
                logger.log(err);
                navigateToLogin(window.location.pathname);
            }
        });
    }
    function handleResponse(response) {
        if (response !== null) {
            var token = response.idToken;
            callApi(token);
        } else {
            // In case multiple accounts exist, you can select
            const currentAccounts = myMsal.getAllAccounts();

            if (currentAccounts.length === 0) {
                // no accounts signed-in, attempt to sign a user in
                myMsal.loginRedirect(loginRequest);
            } else if (currentAccounts.length > 1) {
                alert("multiple accounts");
                myMsal.loginRedirect(loginRequest);
            } else if (currentAccounts.length === 1) {
                const loginRequest2 = {
                    scopes: ["User.ReadWrite"],
                    account: myMsal.getAccountByHomeId(currentAccounts[0].homeAccountId)
                };
                myMsal.acquireTokenSilent(loginRequest2)
                    .then(response => {
                        var token = response.idToken;
                        callApi(token);
                    })

            }
        }
    }

    myMsal.handleRedirectPromise().then(handleResponse).catch((err) => {
        console.log(err)
        logger.log(err);
        router.replace("/ssolanding");
    });

}

//var navigateToResetLink = function (email, username) {
//    window.location.replace(urls.getResetUrl(email, username));
//}
//Timer for logout
// Set the timeout threshold for the session countdown timer in milliseconds (e.g., 60 minutes)
var timeoutThreshold = 60 * 60 * 1000;

// Start the session countdown timer
var countdownTimer = setTimeout(function () {
    // Redirect to the external URL when the countdown finishes
    logout();
}, timeoutThreshold);

// Reset the session countdown timer on each user activity or interaction
function resetCountdownTimer() {
    // Clear the previous countdown timer
    clearTimeout(countdownTimer);
    // Start a new countdown timer
    countdownTimer = setTimeout(function () {
        // Redirect to the external URL when the countdown finishes
        logout();
    }, timeoutThreshold);
}
document.addEventListener("click", resetCountdownTimer);
document.addEventListener("keydown", resetCountdownTimer);
document.addEventListener("mousemove", resetCountdownTimer);

const response401Interceptor = (error) => {
    if (401 === ((error || {}).response || {}).status) {
        //TODO: Refresh token
        //TODO: If refresh fails redirect to login
        //TODO: If refresh passes try the action again somehow...
        var token = authToken.get();
        if (!token.length) { // no token
            //navigate to login - no questions asked
            navigateToLogin(window.location.pathname);
        } else {
            // try to refresh the token
            unprotectedApi.put(
                "/auth",
                {
                    Token: token
                }
            ).then((r) => r.data).then((resp) => {
                authToken.set(resp.token || resp.Token);
                rules.getPermissions(resp.token || resp.Token);
                checkUIPermissions();
                logger.log("refreshed");
            }).catch((err) => {
                logger.log(err)
                //navigate to login - some questions asked
                navigateToLogin(window.location.pathname);
            });
        }
    } else {
        return Promise.reject(error);
    }
};

//Added by Haris Date correction for json serialization
protectedApi.interceptors.request.use(dateInterceptor);
protectedApi.interceptors.request.use(authInterceptor);
protectedApi.interceptors.response.use(response => response, response401Interceptor);

const unprotectedApi = axios.create({
    baseURL: urls.apiBaseUrl
});

unprotectedApi.interceptors.request.use(authInterceptor);

const ssoApi = axios.create({
    baseURL: urls.ssoBaseUrl
});

export default {
    protectedApi,
    unprotectedApi,
    ssoApi,
    navigateToLogin,
    //navigateToResetLink,
    logout
}

